import { jsx } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from "react";
import { eachDayOfInterval, getMonth } from "date-fns";
import { useCalendar } from "../../services/hooks/index.js";
import { Box } from "../../Box/index.js";
import { CALENDAR_MAX_DATE, CALENDAR_MIN_DATE } from "../../services/calendar/index.js";
import { Month } from "./Calendar/index.js";
const YearCalendarInput = ({ year = new Date().getFullYear(), value, onChange, minDate = CALENDAR_MIN_DATE, maxDate = CALENDAR_MAX_DATE, shouldDisableDate, createTooltipText, onRangeClick, holidays, regionalHolidays, readonly, disabled, onDelete, onNoAvailableRange, deletedRanges, onSelectCurrentInterval })=>{
    const calendar = useCalendar();
    const [range, setRange] = useState([
        null,
        null
    ]);
    const [hoverDate, setHoverDate] = useState(null);
    const handleReset = useCallback(()=>{
        setRange([
            null,
            null
        ]);
        null == onSelectCurrentInterval || onSelectCurrentInterval([
            null,
            null
        ]);
    }, [
        onSelectCurrentInterval
    ]);
    const days = useMemo(()=>eachDayOfInterval({
            start: new Date(`${year}-01-01`),
            end: new Date(`${year}-12-31`)
        }), [
        year
    ]);
    const handleChange = useCallback((nextValue)=>{
        if (readonly || disabled) return;
        if (range[0] || range[1]) {
            if (range[0] && range[1] && calendar.isSameDay(range[0], range[1])) {
                let newValue;
                newValue = nextValue >= range[0] ? [
                    range[0],
                    nextValue
                ] : [
                    nextValue,
                    range[0]
                ];
                setRange([
                    null,
                    null
                ]);
                null == onSelectCurrentInterval || onSelectCurrentInterval([
                    null,
                    null
                ]);
                onChange([
                    ...value,
                    newValue
                ]);
            }
        } else {
            setRange([
                nextValue,
                nextValue
            ]);
            null == onSelectCurrentInterval || onSelectCurrentInterval([
                nextValue,
                nextValue
            ]);
            if (onNoAvailableRange && shouldDisableDate && days.every((day)=>shouldDisableDate(day, nextValue))) onNoAvailableRange();
        }
    }, [
        readonly,
        disabled,
        range,
        calendar,
        onSelectCurrentInterval,
        onNoAvailableRange,
        shouldDisableDate,
        days,
        onChange,
        value
    ]);
    const handleDelete = useCallback((date)=>{
        onDelete(value.findIndex((selectedRange)=>date >= selectedRange[0] && date <= selectedRange[1]));
    }, [
        onDelete,
        value
    ]);
    return /*#__PURE__*/ jsx(Box, {
        mb: "8",
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        children: new Array(12).fill(null).map((_, index)=>/*#__PURE__*/ jsx(Month, {
                year: year,
                month: index,
                value: value,
                onChange: handleChange,
                minDate: minDate,
                maxDate: maxDate,
                createTooltipText: createTooltipText,
                shouldDisableDate: shouldDisableDate,
                holidays: holidays,
                regionalHolidays: regionalHolidays,
                onRangeClick: onRangeClick,
                hoverDate: hoverDate,
                setHoverDate: setHoverDate,
                range: range,
                readonly: readonly,
                disabled: disabled,
                onDelete: handleDelete,
                clearable: !!range[0] && range[0].getMonth() === index,
                onClear: handleReset,
                deletedRanges: deletedRanges
            }, getMonth(index)))
    });
};
export { YearCalendarInput };
